import jwtDecode from "jwt-decode";

export function validAuthParameter(authParameter) {
    if (authParameter) {
        try {
            const decodedToken = jwtDecode(authParameter)
            return decodedToken?.email
        } catch (error) {
            return false
        }
    }
    return false
}